import { render } from "./Activitymanagement.vue?vue&type=template&id=40e1dc55&scoped=true"
import script from "./Activitymanagement.js?vue&type=script&lang=js"
export * from "./Activitymanagement.js?vue&type=script&lang=js"

import "./Activitymanagement.vue?vue&type=style&index=0&id=40e1dc55&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40e1dc55"]])

export default __exports__